import {useMutation} from "@tanstack/react-query";
import {removePermissionOverrideMutationOptions} from "./remove-permission-override.mutation-options";

export function useRemovePermissionOverride(userId: string) {
  return useMutation(removePermissionOverrideMutationOptions(userId));
}
